import $ from "jquery";
import "../bootstrap.js";
window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", async () => {
    // Close popup when click close button
    const { closePopupBanner } = await import('../components/popup.js');
    closePopupBanner();

    // Popup banner suppression (session + cookie based)
    const { initPopupBanner } = await import('../components/popup-banner.js');
    initPopupBanner();

    const videoBgEl = document.querySelectorAll('.handle-bg__video');
    if (videoBgEl.length > 0) {
        const { initVideo } = await import('../components/video.js');
        initVideo();
        let timeout;
        window.addEventListener('resize', function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                initVideo();
            }, 300);
        });
    }

    // Information Top Slider
    const informationEls = document.querySelector(".js-information-keyv");
    if (informationEls) {
        const { renderInformationSlider } = await import(
            "../components/swiper.js"
        );
        renderInformationSlider(informationEls);
    }

    const carouselImgEls = document.getElementById("js-slide-thumbnail");
    if (carouselImgEls) {
        const { renderThumbnailKeyvSlider } = await import(
            "../components/swiper.js"
        );
        renderThumbnailKeyvSlider(carouselImgEls);
    }

    const scrollSlideEls = document.getElementById("js-scroll-swiper");
    if (scrollSlideEls) {
        const { renderScrollSlide } = await import("../components/swiper.js");
        renderScrollSlide(scrollSlideEls, true);
    }

    const { pinDecorOnScroll, initIndexCourseTween } = await import("../components/scroll.js");
    pinDecorOnScroll();
    initIndexCourseTween();

    // Graduate Slider
    const sliderGraduateEls = document.querySelectorAll(".js-graduate-slider");
    if (sliderGraduateEls.length > 0) {
        const { renderGraduateHome } = await import("../components/slider.js");
        const { PaginationProgress } = await import("../components/pagination-progress.js");

        sliderGraduateEls.forEach((el) => {
            const splide = renderGraduateHome(el);
            if (!splide) return;

            const pagination = new PaginationProgress(
                splide.root.querySelector(".splide__pagination")
            );

            const DURATION = 5000;
            const INTERVAL = 100;
            let timer = null;
            let elapsed = 0;
            let isVisible = false;

            const startProgress = () => {
                if (!isVisible) return;
                pagination.resetAll();

                const activeIndex = splide.index;
                elapsed = 0;
                clearInterval(timer);

                timer = setInterval(() => {
                    if (!isVisible) return;

                    elapsed += INTERVAL;
                    const percent = Math.min((elapsed / DURATION) * 100, 100);
                    pagination.setProgress(activeIndex, percent);

                    if (percent >= 100) {
                        clearInterval(timer);
                        setTimeout(() => {
                            splide.go(">");
                        }, 150);
                    }
                }, INTERVAL);
            };

            const stopProgress = () => {
                clearInterval(timer);
                timer = null;
            };

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            isVisible = true;
                            startProgress();
                        } else {
                            isVisible = false;
                            stopProgress();
                        }
                    });
                },
                { threshold: 0.3 }
            );
            observer.observe(el);

            splide.on("moved", () => {
                clearInterval(timer);
                startProgress();
            });

            window.addEventListener(
                "resize",
                () => {
                    pagination.refresh();
                    clearInterval(timer);
                    startProgress();
                },
                { passive: true }
            );

            splide.on("mounted", () => {
                setTimeout(() => startProgress(), 400);
            });
        });
    }

    const searchSlideEls = document.getElementById("handle-search__slide");
    if (searchSlideEls) {
        const { renderSwiperSearch } = await import("../components/swiper.js");
        renderSwiperSearch(searchSlideEls);
    }

    const loadMoreEl = document.querySelectorAll('.handle-load-content');
    if (loadMoreEl) {
        const { initLoadMore } = await import('../components/load-more.js');
        initLoadMore();
    }

    // Splider Real Talk
    const sliderRealEls = document.querySelectorAll(".js-real-talk-slider");
    if (sliderRealEls.length > 0) {
        const { YouTubeManager } = await import(
            "../components/video-youtube.js"
        );
        const { renderRealTalkSlider } = await import("../components/slider.js");
        const { PaginationProgress } = await import(
            "../components/pagination-progress.js"
        );

        const yt = new YouTubeManager();
        await yt.init();

        sliderRealEls.forEach((el) => {
            const splide = renderRealTalkSlider(el);
            yt.createPlayers(el);

            const pagination = new PaginationProgress(
                splide.root.querySelector(".splide__pagination")
            );

            // When the video ends → move to the next slide
            yt.onVideoEnded = () => {
                splide.go(">");
            };

            const updateVideoState = () => {
                const activeIndex = splide.index;
                const centerSlide = splide.Components.Slides.getAt(activeIndex)?.slide;
                if (!centerSlide) return;

                const videoEl = centerSlide.querySelector(".js-lazy-video");
                if (!videoEl) return;

                const iframe = videoEl.querySelector("iframe");
                const player = iframe ? yt.players[iframe.id] : null;

                // If less than 2/3 is displayed → pause everything and come back
                if (!yt.shouldPlay(videoEl)) {
                    yt.pauseAll();
                    return;
                }

                // If there is no iframe → load for the first time
                if (!iframe) {
                    yt.loadAndPlay(videoEl);
                    const newIframe = videoEl.querySelector("iframe");
                    yt.play(newIframe, (percent) =>
                        pagination.setProgress(activeIndex, percent)
                    );
                    return;
                }

                // If the video has ended → restart
                const state = player.getPlayerState?.();
                if (state === YT.PlayerState.ENDED) {
                    yt.restart(iframe);
                } else {
                    // Only play the video that has an iframe
                    yt.play(iframe, (percent) =>
                        pagination.setProgress(activeIndex, percent)
                    );
                }
            };

            splide.on("mounted", () => setTimeout(updateVideoState, 500));
            splide.on("move", () => {
                yt.pauseAll();
                updateVideoState();
            });

            window.addEventListener("scroll", updateVideoState, {
                passive: true,
            });
            window.addEventListener("load", updateVideoState, {
                passive: true,
            });
            window.addEventListener(
                "resize",
                () => {
                    pagination.refresh();
                    updateVideoState();
                },
                { passive: true }
            );
        });
    }

    const { disableContextImage } = await import("../components/detect-image.js");
    disableContextImage("#news-list");

    // News Loader
    const { newsLoader } = await import("../components/news-loader.js");
    newsLoader();
});
